<template>
  <div
    ref="container"
    class="df scroll-box"
    :style="{
      width: '100%',
      height: '100%',
      overflowY: 'auto',
    }"
  >
    <template v-if="stepsData.length">
      <div
        :style="{
          width:
            cellConunt + 1 > stepsData.length
              ? cellWidth * (stepsData.length + 1) + 'px'
              : cellWidth * (cellConunt + 1) + 'px',
          margin: `0 0px 90px`,
        }"
      >
        <div
          v-for="item in Math.ceil(stepsData.length / cellConunt)"
          :key="item"
          class="df aic"
          :style="{
            marginLeft: item % 2 == 1 ? cellWidth + 'px' : '0',
            marginRight: item % 2 == 0 ? cellWidth + 'px' : '0',
            flexDirection: item % 2 == 0 ? 'row-reverse' : 'row',
          }"
        >
          <template v-for="dataItem in cellConunt">
            <div
              :key="dataItem"
              :style="{
                position: 'relative',
                width: cellWidth + 'px',
                height: cellHeight + 'px',
                boxSizing: 'border-box',
              }"
              v-if="stepsData.length > (item - 1) * cellConunt + dataItem - 1"
            >
              <StepItem
                style="position: absolute; left: 0; top: 0"
                :outer-width="cellWidth"
                :outer-height="
                  dataItem == cellConunt ? 2 * cellHeight : cellHeight
                "
                :center-width="centerWidth"
                :center-height="centerHeight"
              >
                <template #top v-if="dataItem == cellConunt">
                  <div
                    :style="{
                      width: '100%',
                      height: '100%',
                      boxSizing: 'border-box',
                      paddingLeft:
                        item % 2 == 1
                          ? ''
                          : centerWidth / 2 - lineWidth / 2 + 'px',
                      paddingRight:
                        item % 2 == 1
                          ? centerWidth / 2 - lineWidth / 2 + 'px'
                          : '',
                      paddingTop: cellHeight / 2 - lineWidth / 2 + 'px',
                    }"
                  >
                    <div
                      :style="{
                        width: '100%',
                        height: '100%',
                        borderTop: lineWidth + 'px solid #fff',
                        borderLeft:
                          item % 2 == 1 ? '' : lineWidth + 'px solid #fff',
                        borderRight:
                          item % 2 == 1 ? lineWidth + 'px solid #fff' : '',
                        borderTopLeftRadius: item % 2 == 1 ? '' : '20px',
                        borderTopRightRadius: item % 2 == 1 ? '20px' : '',
                      }"
                    ></div>
                  </div>
                </template>
                <template
                  #bottom
                  v-if="dataItem == cellConunt && !isEnd(item, dataItem).bottom"
                >
                  <div
                    :style="{
                      width: '100%',
                      height: '100%',
                      boxSizing: 'border-box',
                      paddingLeft:
                        item % 2 == 1
                          ? ''
                          : centerWidth / 2 - lineWidth / 2 + 'px',
                      paddingRight:
                        item % 2 == 1
                          ? centerWidth / 2 - lineWidth / 2 + 'px'
                          : '',
                      paddingBottom: cellHeight / 2 - lineWidth / 2 + 'px',
                    }"
                  >
                    <div
                      :style="{
                        width: '100%',
                        height: '100%',
                        borderBottom: lineWidth + 'px solid #fff',
                        borderLeft:
                          item % 2 == 1 ? '' : lineWidth + 'px solid #fff',
                        borderRight:
                          item % 2 == 1 ? lineWidth + 'px solid #fff' : '',
                        borderBottomLeftRadius: item % 2 == 1 ? '' : '20px',
                        borderBottomRightRadius: item % 2 == 1 ? '20px' : '',
                      }"
                    ></div>
                  </div>
                </template>
                <template
                  #left
                  v-if="
                    dataItem != cellConunt &&
                    (item - 1) * cellConunt + dataItem - 1 != 0 &&
                    !isEnd(item, dataItem).left
                  "
                >
                  <div style="width: 100%; height: 100%" class="df aic jcc">
                    <div
                      :style="{
                        width: '100%',
                        height: lineWidth + 'px',
                        background: '#fff',
                      }"
                    ></div>
                  </div>
                </template>
                <template
                  #right
                  v-if="dataItem != cellConunt && !isEnd(item, dataItem).right"
                >
                  <div style="width: 100%; height: 100%" class="df aic jcc">
                    <div
                      :style="{
                        width: '100%',
                        height: lineWidth + 'px',
                        background: '#fff',
                      }"
                    ></div>
                  </div>
                </template>
                <template #itemA v-if="dataItem == cellConunt && item % 2 == 1">
                  <div
                    :style="
                      'box-sizing: border-box;width: 100%; height: 100%; padding-top:' +
                      centerHeight / 2 +
                      'px'
                    "
                  >
                    <div style="width: 100%; height: 100%" class="df aic jcc">
                      <div
                        :style="{
                          width: '100%',
                          height: lineWidth + 'px',
                          background: '#fff',
                        }"
                      ></div>
                    </div>
                  </div>
                </template>
                <template #itemB v-if="dataItem == cellConunt && item % 2 == 0">
                  <div
                    :style="
                      'box-sizing: border-box;width: 100%; height: 100%; padding-top:' +
                      centerHeight / 2 +
                      'px'
                    "
                  >
                    <div style="width: 100%; height: 100%" class="df aic jcc">
                      <div
                        :style="{
                          width: '100%',
                          height: lineWidth + 'px',
                          background: '#fff',
                        }"
                      ></div>
                    </div>
                  </div>
                </template>
                <template
                  #itemC
                  v-if="
                    dataItem == cellConunt &&
                    item % 2 == 1 &&
                    !isEnd(item, dataItem).bottom
                  "
                >
                  <div
                    :style="
                      'box-sizing: border-box;width: 100%; height: 100%; padding-bottom:' +
                      centerHeight / 2 +
                      'px'
                    "
                  >
                    <div style="width: 100%; height: 100%" class="df aic jcc">
                      <div
                        :style="{
                          width: '100%',
                          height: lineWidth + 'px',
                          background: '#fff',
                        }"
                      ></div>
                    </div>
                  </div>
                </template>
                <template
                  #itemD
                  v-if="
                    dataItem == cellConunt &&
                    item % 2 == 0 &&
                    !isEnd(item, dataItem).bottom
                  "
                >
                  <div
                    :style="
                      'box-sizing: border-box;width: 100%; height: 100%; padding-bottom:' +
                      centerHeight / 2 +
                      'px'
                    "
                  >
                    <div style="width: 100%; height: 100%" class="df aic jcc">
                      <div
                        :style="{
                          width: '100%',
                          height: lineWidth + 'px',
                          background: '#fff',
                        }"
                      ></div>
                    </div>
                  </div>
                </template>
                <template #center>
                  <div
                    @click="openPopup(item, dataItem)"
                    class="process-node"
                    :style="
                      'border-top: 3px solid ' +
                      [
                        '#4d9eff',
                        '#ff8812',
                        '#a0d9a3',
                        '#a27ce6',
                        '#ffa940',
                        '#ff7caf',
                        '#00c6ff',
                      ][((item - 1) * cellConunt + dataItem - 1) % 5]
                    "
                  >
                    <div class="process-header">
                      <div
                        class="process-name"
                        :style="
                          'color:' +
                          [
                            '#4d9eff',
                            '#ff8812',
                            '#a0d9a3',
                            '#a27ce6',
                            '#ffa940',
                            '#ff7caf',
                            '#00c6ff',
                          ][((item - 1) * cellConunt + dataItem - 1) % 5]
                        "
                      >
                        {{
                          stepsData[(item - 1) * cellConunt + dataItem - 1]
                            .stepName
                        }}
                      </div>
                      <div
                        class="process-status status-normal"
                        v-if="
                          !stepsData[(item - 1) * cellConunt + dataItem - 1]
                            .abnormal &&
                          !stepsData[(item - 1) * cellConunt + dataItem - 1]
                            .lossAbnormal &&
                          !stepsData[(item - 1) * cellConunt + dataItem - 1]
                            .outputLossAbnormal
                        "
                      ></div>
                      <div v-else class="process-status status-critical"></div>
                    </div>
                    <div class="process-content">
                      <div class="process-section">
                        <div class="section-title">
                          <i class="fas fa-arrow-down"></i>
                          <span>投入</span>
                        </div>
                        <div class="product-list">
                          <div
                            class="product-item"
                            v-for="(dataItem, dataIndex) in stepsData[
                              (item - 1) * cellConunt + dataItem - 1
                            ].dataList
                              .filter((dataItem) => dataItem.type == 0)
                              .filter((dataItem, dataIndex) => dataIndex < 2)"
                            :key="dataIndex"
                          >
                            <span class="product-name">{{
                              dataItem.name
                            }}</span>
                            <span class="product-value">{{
                              dataItem.data
                            }}</span>
                          </div>
                          <div
                            class="product-item"
                            style="padding: 4px 0; color: #909399"
                            v-if="
                              !stepsData[
                                (item - 1) * cellConunt + dataItem - 1
                              ].dataList.filter(
                                (dataItem) => dataItem.type == 0
                              ).length
                            "
                          >
                            未设置
                          </div>

                          <div
                            class="product-item"
                            style="color: #909399"
                            v-if="
                              stepsData[
                                (item - 1) * cellConunt + dataItem - 1
                              ].dataList.filter(
                                (dataItem) => dataItem.type == 0
                              ).length > 2
                            "
                          >
                            …
                          </div>
                        </div>
                      </div>
                      <div class="process-section">
                        <div class="section-title">
                          <i class="fas fa-arrow-up"></i>
                          <span>产出</span>
                        </div>
                        <div class="product-list">
                          <div
                            class="product-item"
                            v-for="(dataItem, dataIndex) in stepsData[
                              (item - 1) * cellConunt + dataItem - 1
                            ].dataList
                              .filter((dataItem) => dataItem.type == 1)
                              .filter((dataItem, dataIndex) => dataIndex < 2)"
                            :key="dataIndex"
                          >
                            <span class="product-name">{{
                              dataItem.name
                            }}</span>
                            <span class="product-value">{{
                              dataItem.data
                            }}</span>
                          </div>
                          <div
                            class="product-item"
                            style="padding: 4px 0; color: #909399"
                            v-if="
                              !stepsData[
                                (item - 1) * cellConunt + dataItem - 1
                              ].dataList.filter(
                                (dataItem) => dataItem.type == 1
                              ).length
                            "
                          >
                            未设置
                          </div>

                          <div
                            class="product-item"
                            style="color: #909399"
                            v-if="
                              stepsData[
                                (item - 1) * cellConunt + dataItem - 1
                              ].dataList.filter(
                                (dataItem) => dataItem.type == 1
                              ).length > 2
                            "
                          >
                            …
                          </div>
                        </div>
                      </div>

                      <div class="process-balance-box">
                        <div class="process-balance">
                          <span class="balance-label">目标达成率</span>
                          <span
                            class="balance-value balance-good"
                            v-if="
                              !stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .abnormal
                            "
                          >
                            {{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .balanceRate
                            }}%
                          </span>
                          <span class="balance-value balance-critical" v-else
                            >{{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .balanceRate
                            }}%
                          </span>
                        </div>
                        <div class="process-balance" style="margin-top: 5px">
                          <span class="balance-label">投入损耗率</span>
                          <span
                            class="balance-value balance-good"
                            v-if="
                              !stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .lossAbnormal
                            "
                            >{{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .lossRate
                            }}%</span
                          >
                          <span class="balance-value balance-critical" v-else
                            >{{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .lossRate
                            }}%</span
                          >
                        </div>
                        <div class="process-balance" style="margin-top: 5px">
                          <span class="balance-label">产出损耗率</span>
                          <span
                            class="balance-value balance-good"
                            v-if="
                              !stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .outputLossAbnormal
                            "
                            >{{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .outputLossRate
                            }}%</span
                          >
                          <span class="balance-value balance-critical" v-else
                            >{{
                              stepsData[(item - 1) * cellConunt + dataItem - 1]
                                .outputLossRate
                            }}%</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </StepItem>
            </div>
          </template>
        </div>
      </div>
    </template>
    <el-dialog
      title="工序物料平衡"
      :visible.sync="popupVisible"
      width="60%"
      custom-class="daily-box"
      @closed="popupClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="df fdc"
        style="background-color: #eee; gap: 20px; height: 100%"
      >
        <div style="width: 100%; height: 130px; gap: 10px" class="df fdr">
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              overflow: hidden;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #8980c1; font-size: 34px; width: 100%"
            >
              {{ procedureRate }}%
            </div>
            <div
              class="df aic jcc"
              style="font-size: 14px; color: #909399; width: 100%"
            >
              实际目标达成率
            </div>
            <div style="width: 100%; height: 19px"></div>
          </div>
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #d6a799; font-size: 34px; width: 100%"
            >
              <span v-if="theoryProcedureRate.id">
                {{ theoryProcedureRate.value }}%
              </span>
              <span v-else> 未配置 </span>
            </div>
            <div
              class="df aic jcb"
              style="
                font-size: 14px;
                color: #909399;
                width: 100%;
                padding: 0 10px;
              "
            >
              <div style="flex: 2">理论目标得率</div>
            </div>
            <el-popover
              placement="bottom"
              width="400"
              trigger="click"
              v-model="showAdd2"
              @show="openPopover2"
              @hide="showAdd2 = false"
            >
              <div style="padding: 20px 20px 0">
                <div class="df aic jcc">
                  <span class="special-title" style="margin-bottom: 10px">
                    {{ editId === null ? "配置" : "修改" }}
                  </span>
                </div>

                <el-form
                  ref="form"
                  :model="formData"
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item label="理论得率">
                    <el-input
                      placeholder="请输入理论得率"
                      v-model="formData.dataInfo"
                      type="number"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="df aic jcc">
                      <el-button
                        type="primary"
                        @click="handleAdd"
                        v-if="theoryLossRate.id === null"
                        >提交</el-button
                      >
                      <el-button type="primary" @click="handleEdit1" v-else
                        >修改</el-button
                      >
                      <el-button
                        @click="showAdd2 = false"
                        style="margin-left: 10px"
                        >取消</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
              </div>

              <div slot="reference" style="color: #409eff; gap: 5px; flex: 1">
                <div class="df aic pointer">
                  去配置<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </el-popover>
          </div>
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              overflow: hidden;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #ccb38f; font-size: 34px; width: 100%"
            >
              {{ lossRateData }}%
            </div>
            <div
              class="df aic jcc"
              style="font-size: 14px; color: #909399; width: 100%"
            >
              工序原料损耗率
            </div>
            <div style="width: 100%; height: 19px"></div>
          </div>
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              overflow: hidden;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #8fcccc; font-size: 34px; width: 100%"
            >
              {{ theoryLossRate.value }}%
            </div>
            <div
              class="df aic jcc"
              style="font-size: 14px; color: #909399; width: 100%"
            >
              工序原料理论损耗率
            </div>
            <el-popover
              placement="bottom"
              width="400"
              trigger="click"
              v-model="showAdd1"
              @show="openPopover1"
              @hide="showAdd1 = false"
            >
              <div style="padding: 20px 20px 0">
                <div class="df aic jcc">
                  <span class="special-title" style="margin-bottom: 10px">
                    {{ editId === null ? "配置" : "修改" }}
                  </span>
                </div>

                <el-form
                  ref="form"
                  :model="formData"
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item label="理论损耗率">
                    <el-input
                      placeholder="请输入理论损耗率"
                      v-model="formData.dataInfo"
                      type="number"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="df aic jcc">
                      <el-button
                        type="primary"
                        @click="handleAdd"
                        v-if="theoryLossRate.id === null"
                        >提交</el-button
                      >
                      <el-button type="primary" @click="handleEdit1" v-else
                        >修改</el-button
                      >
                      <el-button
                        @click="showAdd1 = false"
                        style="margin-left: 10px"
                        >取消</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
              </div>

              <div slot="reference" style="color: #409eff; gap: 5px; flex: 1">
                <div class="df aic pointer">
                  去配置<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </el-popover>
          </div>
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              overflow: hidden;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #cc8fb3; font-size: 34px; width: 100%"
            >
              {{ outputLossRate }}%
            </div>
            <div
              class="df aic jcc"
              style="font-size: 14px; color: #909399; width: 100%"
            >
              工序产出损耗率
            </div>
            <div style="width: 100%; height: 19px"></div>
          </div>
          <div
            class="df aic jcc fdc"
            style="
              border-radius: 8px;
              background-color: #fff;
              overflow: hidden;
              flex: 1;
              height: 100%;
              width: 0;
              overflow: hidden;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1),
                0 1px 1px rgba(255, 255, 255, 0.5) inset;
              border: 1px solid rgba(255, 255, 255, 0.7);
            "
          >
            <div
              class="df aic jcc stat-value"
              style="color: #b38fcc; font-size: 34px; width: 100%"
            >
              {{ theoryLossRate1.value }}%
            </div>
            <div
              class="df aic jcc"
              style="font-size: 14px; color: #909399; width: 100%"
            >
              工序产出理论损耗率
            </div>
            <el-popover
              placement="bottom"
              width="400"
              trigger="click"
              v-model="showAdd3"
              @show="openPopover3"
              @hide="showAdd3 = false"
            >
              <div style="padding: 20px 20px 0">
                <div class="df aic jcc">
                  <span class="special-title" style="margin-bottom: 10px">
                    {{ editId === null ? "配置" : "修改" }}
                  </span>
                </div>

                <el-form
                  ref="form"
                  :model="formData"
                  label-width="120px"
                  label-position="left"
                >
                  <el-form-item label="理论损耗率">
                    <el-input
                      placeholder="请输入理论损耗率"
                      v-model="formData.dataInfo"
                      type="number"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div class="df aic jcc">
                      <el-button
                        type="primary"
                        @click="handleAdd"
                        v-if="theoryLossRate.id === null"
                        >提交</el-button
                      >
                      <el-button type="primary" @click="handleEdit1" v-else
                        >修改</el-button
                      >
                      <el-button
                        @click="showAdd3 = false"
                        style="margin-left: 10px"
                        >取消</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
              </div>

              <div slot="reference" style="color: #409eff; gap: 5px; flex: 1">
                <div class="df aic pointer">
                  去配置<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </el-popover>
          </div>
        </div>
        <div
          style="
            width: 100%;
            flex: 1;
            height: 0;
            border-radius: 5px;
            overflow: hidden;
          "
        >
          <el-tabs
            v-model="tabsValue"
            tab-position="left"
            class="cover"
            @tab-click="
              editId = null;
              showAdd = false;
              showConfig = false;
              showCharts = false;
              conversionRate(formData.otherId, 0);
            "
          >
            <el-tab-pane label="批次变化趋势" name="批次变化趋势">
              <div
                class="cover df fdc"
                style="
                  background-color: #fff;
                  border-radius: 5px;
                  overflow: hidden;
                  padding: 30px 20px;
                "
              >
                <div
                  class="df jcb aic"
                  style="margin-bottom: 40px; padding: 20px 20px 0"
                >
                  <span class="special-title">批次数据变化趋势</span>
                  <div style="width: 380px">
                    <el-date-picker
                      size="small"
                      v-model="timeValue2"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      @change="timeChange(0)"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div
                  style="flex: 1; height: 0; width: 100%"
                  v-loading="inversionLoading"
                >
                  <div
                    style="
                      width: 100%;
                      height: 100%;
                      background-color: #f5f7fa;
                      border-radius: 10px;
                    "
                  >
                    <Charts3
                      :dataList="inversionList"
                      v-if="!inversionLoading && inversionList.length"
                      :type="0"
                    />
                    <el-empty
                      description="无相关数据"
                      v-else-if="!inversionLoading && !inversionList.length"
                    ></el-empty>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="投料列表" name="投料列表">
              <div class="df fdr" style="width: 100%; gap: 10px; height: 100%">
                <div
                  class="cover df fdc"
                  style="
                    flex: 2;
                    width: 0;
                    height: 100%;
                    background-color: #f8f8f8;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button
                      slot="reference"
                      size="small"
                      type="primary"
                      @click="openAdd(0)"
                      >新增投料</el-button
                    >
                  </div>
                  <div class="" style="flex: 1; height: 0">
                    <div class="cover" style="overflow: auto; padding: 10px">
                      <div class="modal-body">
                        <div
                          class="material-card"
                          v-for="(item, index) in inputList"
                          :key="item.id"
                        >
                          <div class="material-header">
                            <h3 class="material-name">{{ item.name }}</h3>
                          </div>
                          <div class="tag-container">
                            <div class="included-tag" v-if="item.isTotal">
                              计入总投料
                            </div>
                            <div
                              :class="{
                                'template-tag': true,
                                'feed-template': item.source,
                                'process-template': !item.source,
                              }"
                            >
                              {{ item.source ? "投料模板" : "工序模板" }}
                            </div>
                          </div>
                          <div class="material-content">
                            <div class="info-item">
                              <div class="info-label">投料量</div>
                              <div class="highlight-value">
                                {{ item.data }}kg
                              </div>
                            </div>

                            <div class="material-content">
                              <div class="info-item">
                                <div class="info-label">产成率</div>
                                <div class="highlight-value">
                                  <el-tag
                                    @click="getUtilizationData(item.id)"
                                    style="margin: 0 3px"
                                    type="warning"
                                    v-for="uItem in item.utilization"
                                    :key="uItem.id"
                                    >{{ uItem.name }}产成率:{{
                                      uItem.utilData
                                    }}%</el-tag
                                  >
                                </div>
                              </div>
                            </div>
                            <!-- <div class="info-item">
                        <div class="info-label">投料数据</div>
                        <div class="info-value">{{}}</div>
                      </div> -->
                          </div>
                          <div
                            class="material-actions"
                            style="padding: 8px 30px 0"
                          >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              style="color: #e6a23c"
                              @click="openConfig(index)"
                              >理论产量</el-button
                            >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              style="margin-left: 10px"
                              @click="editItem(item)"
                              >修改</el-button
                            >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              @click="handleDel(item)"
                              style="margin-left: 10px; color: #f56c6c"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showAdd"
                  class="cover df fdc"
                  style="
                    flex: 1;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div>
                    <div class="df aic jcc" style="margin-bottom: 10px">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "新增" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <template v-if="[0, 1, 2, 5].includes(formData.type)">
                        <el-form-item
                          :label="formData.type ? '产出名称' : '投料名称'"
                        >
                          <el-input v-model="formData.name"></el-input>
                        </el-form-item>

                        <el-form-item label="类型">
                          <el-select
                            v-model="formData.type"
                            placeholder="请选择活动区域"
                            @change="typeChange"
                          >
                            <el-option label="投入" :value="0"></el-option>
                            <el-option label="产出" :value="1"></el-option>
                            <el-option label="损耗" :value="2"></el-option>
                            <el-option label="产出损耗" :value="5"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            ['投料来源', '产出来源', '损耗来源'][formData.type]
                          "
                        >
                          <el-select
                            v-model="formData.source"
                            placeholder="请选择活动区域"
                            @change="sourceChange"
                          >
                            <el-option label="工序模版" :value="0"></el-option>
                            <el-option
                              label="投料模版"
                              :value="1"
                              v-if="!formData.type"
                            ></el-option>
                            <el-option
                              label="绑码列表"
                              :value="2"
                              v-if="formData.type == 1"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="绑码时间筛选"
                          v-if="formData.source == 2"
                        >
                          <el-date-picker
                            v-model="timeValue1"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          :label="
                            [
                              '投料数据',
                              ['投料数据', '产出数据', '损耗数据'][
                                formData.type
                              ],
                              '绑码批次',
                            ][formData.source]
                          "
                        >
                          <el-select
                            v-model="formData.sourceId"
                            placeholder="请选择"
                            @visible-change="openSelect"
                            @change="selectChange"
                            :loading="dataLoading"
                          >
                            <template v-if="formData.source !== 2">
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </template>
                            <template v-else>
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                                <span style="float: left">{{
                                  item.goodsName
                                }}</span>
                                <span
                                  style="
                                    float: right;
                                    color: #8492a6;
                                    font-size: 13px;
                                  "
                                  >{{ item.label }}</span
                                >
                              </el-option>
                            </template>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            formData.type ? '是否计入总产出' : '是否计入总投料'
                          "
                          v-if="![2, 5].includes(formData.type)"
                        >
                          <div class="df aic">
                            <el-switch v-model="formData.isTotal"></el-switch>
                          </div>
                        </el-form-item>
                      </template>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="handleAdd"
                          v-if="editId === null"
                          >提交</el-button
                        >
                        <el-button type="primary" @click="handleEdit" v-else
                          >修改</el-button
                        >
                        <el-button
                          @click="showAdd = false"
                          style="margin-left: 10px"
                          >取消</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div
                  v-if="showConfig"
                  class="cover df fdc"
                  style="
                    flex: 3;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div
                    class="df"
                    style="flex-direction: column; height: 100%; width: 100%"
                  >
                    <div
                      class="df aic jcb pointer"
                      style="width: 100%; padding: 20px 20px 0"
                    >
                      <div></div>
                      <span class="special-title">每100kg理论产量</span>
                      <div>
                        <i
                          @click="showConfig = false"
                          class="el-icon-close"
                          style="font-size: 24px; color: #909399"
                        ></i>
                      </div>
                    </div>
                    <div
                      style="flex: 1; width: 100%; height: 0; overflow: auto"
                      class="scroll-box"
                    >
                      <div style="width: 100%; padding: 0 20px 20px">
                        <el-table :data="outputList" style="width: 100%">
                          <el-table-column
                            prop="name"
                            label="产出名称"
                            width="140"
                            header-align="center"
                            align="center"
                          >
                          </el-table-column>
                          <el-table-column
                            prop="data"
                            label="每100kg理论产量"
                            width="120"
                            header-align="center"
                            align="center"
                          >
                            <template slot-scope="scope">
                              <div
                                v-if="
                                  theoreticalList[checkedIndex][scope.$index]
                                    .isEdit
                                "
                              >
                                <el-input
                                  placeholder="请输入理论产量"
                                  v-model="
                                    theoreticalList[checkedIndex][scope.$index]
                                      .theoretical
                                  "
                                >
                                  <template slot="append">kg</template>
                                </el-input>
                              </div>
                              <div v-else class="df aic jcc">
                                <span
                                  v-if="
                                    inputList[checkedIndex].theoretical &&
                                    JSON.parse(
                                      inputList[checkedIndex].theoretical
                                    ).length &&
                                    JSON.parse(
                                      inputList[checkedIndex].theoretical
                                    ).filter(
                                      (tItem) => tItem.id === scope.row.id
                                    ).length
                                  "
                                >
                                  {{
                                    JSON.parse(
                                      inputList[checkedIndex].theoretical
                                    ).filter(
                                      (tItem) => tItem.id === scope.row.id
                                    )[0].theoretical
                                  }}kg
                                </span>
                                <span v-else style="color: #909399">
                                  未理论产量配置，请先进行配置
                                </span>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="操作"
                            width="100"
                            header-align="center"
                            align="center"
                          >
                            <template slot-scope="scope">
                              <div
                                class="df aic jcc"
                                style="gap: 8px"
                                v-if="
                                  theoreticalList[checkedIndex][scope.$index]
                                    .isEdit
                                "
                              >
                                <el-button
                                  size="mini"
                                  type="success"
                                  @click="
                                    editTheoretical(checkedIndex, scope.$index)
                                  "
                                >
                                  完成
                                </el-button>
                                <el-button
                                  size="mini"
                                  type="primary"
                                  style="margin: 0"
                                  @click="
                                    changeEditFlag(
                                      checkedIndex,
                                      scope.$index,
                                      false
                                    )
                                  "
                                >
                                  取消
                                </el-button>
                              </div>
                              <div v-else class="df aic jcc">
                                <el-button
                                  size="mini"
                                  type="primary"
                                  @click="
                                    changeEditFlag(
                                      checkedIndex,
                                      scope.$index,
                                      true
                                    )
                                  "
                                >
                                  配置
                                </el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showCharts"
                  class="cover df fdc"
                  style="
                    position: relative;
                    flex: 3;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 200px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <i
                    class="el-icon-close pointer"
                    @click="showCharts = false"
                    style="
                      position: absolute;
                      right: 20px;
                      top: 20px;
                      font-size: 24px;
                    "
                  ></i>

                  <Charts4 :dataList="utilizationData" />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="产出列表" name="产出列表"
              ><div class="df fdr" style="width: 100%; gap: 10px; height: 100%">
                <div
                  class="cover df fdc"
                  style="
                    flex: 2;
                    width: 0;
                    height: 100%;
                    background-color: #f8f8f8;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button
                      slot="reference"
                      size="small"
                      type="primary"
                      @click="openAdd(1)"
                      >新增产出</el-button
                    >
                  </div>
                  <div class="" style="flex: 1; height: 0">
                    <div class="cover" style="overflow: auto; padding: 10px">
                      <div class="modal-body">
                        <div
                          class="material-card"
                          v-for="item in outputList"
                          :key="item.id"
                        >
                          <div class="material-header">
                            <h3 class="material-name">{{ item.name }}</h3>
                          </div>
                          <div class="tag-container">
                            <div class="included-tag" v-if="item.isTotal">
                              计入总产出
                            </div>
                            <div
                              :class="{
                                'template-tag': true,
                                'feed-template': item.source,
                                'process-template': !item.source,
                              }"
                            >
                              {{ item.source ? "绑码列表" : "工序模板" }}
                            </div>
                          </div>

                          <div class="material-content">
                            <div class="info-item">
                              <div class="info-label">产出量</div>
                              <div class="highlight-value">
                                {{ item.data }}kg
                              </div>
                            </div>
                          </div>
                          <div class="material-actions">
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              style="margin-left: 10px"
                              @click="editItem(item)"
                              >修改</el-button
                            >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              @click="handleDel(item)"
                              style="margin-left: 10px; color: #f56c6c"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showAdd"
                  class="cover df fdc"
                  style="
                    flex: 1;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div>
                    <div class="df aic jcc" style="margin-bottom: 10px">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "新增" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <template v-if="[0, 1, 2, 5].includes(formData.type)">
                        <el-form-item
                          :label="formData.type ? '产出名称' : '投料名称'"
                        >
                          <el-input v-model="formData.name"></el-input>
                        </el-form-item>

                        <el-form-item label="类型">
                          <el-select
                            v-model="formData.type"
                            placeholder="请选择活动区域"
                            @change="typeChange"
                          >
                            <el-option label="投入" :value="0"></el-option>
                            <el-option label="产出" :value="1"></el-option>
                            <el-option label="损耗" :value="2"></el-option>
                            <el-option label="产出损耗" :value="5"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            ['投料来源', '产出来源', '损耗来源'][formData.type]
                          "
                        >
                          <el-select
                            v-model="formData.source"
                            placeholder="请选择活动区域"
                            @change="sourceChange"
                          >
                            <el-option label="工序模版" :value="0"></el-option>
                            <el-option
                              label="投料模版"
                              :value="1"
                              v-if="!formData.type"
                            ></el-option>
                            <el-option
                              label="绑码列表"
                              :value="2"
                              v-if="formData.type == 1"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="绑码时间筛选"
                          v-if="formData.source == 2"
                        >
                          <el-date-picker
                            v-model="timeValue1"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          :label="
                            [
                              '投料数据',
                              ['投料数据', '产出数据', '损耗数据'][
                                formData.type
                              ],
                              '绑码批次',
                            ][formData.source]
                          "
                        >
                          <el-select
                            v-model="formData.sourceId"
                            placeholder="请选择"
                            @visible-change="openSelect"
                            @change="selectChange"
                            :loading="dataLoading"
                          >
                            <template v-if="formData.source !== 2">
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </template>
                            <template v-else>
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                                <span style="float: left">{{
                                  item.goodsName
                                }}</span>
                                <span
                                  style="
                                    float: right;
                                    color: #8492a6;
                                    font-size: 13px;
                                  "
                                  >{{ item.label }}</span
                                >
                              </el-option>
                            </template>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            formData.type ? '是否计入总产出' : '是否计入总投料'
                          "
                          v-if="![2, 5].includes(formData.type)"
                        >
                          <div class="df aic">
                            <el-switch v-model="formData.isTotal"></el-switch>
                          </div>
                        </el-form-item>
                      </template>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="handleAdd"
                          v-if="editId === null"
                          >提交</el-button
                        >
                        <el-button type="primary" @click="handleEdit" v-else
                          >修改</el-button
                        >
                        <el-button
                          @click="showAdd = false"
                          style="margin-left: 10px"
                          >取消</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="原料损耗列表" name="原料损耗列表">
              <div class="df fdr" style="width: 100%; gap: 10px; height: 100%">
                <div
                  class="cover df fdc"
                  style="
                    flex: 2;
                    width: 0;
                    height: 100%;
                    background-color: #f8f8f8;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button
                      slot="reference"
                      size="small"
                      type="primary"
                      @click="openAdd(2)"
                      >新增原料损耗</el-button
                    >
                  </div>
                  <div class="" style="flex: 1; height: 0">
                    <div class="cover" style="overflow: auto; padding: 10px">
                      <div class="modal-body">
                        <div
                          class="material-card"
                          v-for="item in lossList"
                          :key="item.id"
                        >
                          <div class="material-header">
                            <h3 class="material-name">{{ item.name }}</h3>
                          </div>
                          <div class="material-content">
                            <div class="info-item">
                              <div class="info-label">原料损耗量</div>
                              <div class="highlight-value">
                                {{ item.data }}kg
                              </div>
                            </div>
                          </div>
                          <div class="material-actions">
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              style="margin-left: 10px"
                              @click="editItem(item)"
                              >修改</el-button
                            >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              @click="handleDel(item)"
                              style="margin-left: 10px; color: #f56c6c"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showAdd"
                  class="cover df fdc"
                  style="
                    flex: 1;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div>
                    <div class="df aic jcc" style="margin-bottom: 10px">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "新增" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <template v-if="[0, 1, 2, 5].includes(formData.type)">
                        <el-form-item
                          :label="formData.type ? '产出名称' : '投料名称'"
                        >
                          <el-input v-model="formData.name"></el-input>
                        </el-form-item>

                        <el-form-item label="类型">
                          <el-select
                            v-model="formData.type"
                            placeholder="请选择活动区域"
                            @change="typeChange"
                          >
                            <el-option label="投入" :value="0"></el-option>
                            <el-option label="产出" :value="1"></el-option>
                            <el-option label="损耗" :value="2"></el-option>
                            <el-option label="产出损耗" :value="5"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            ['投料来源', '产出来源', '损耗来源'][formData.type]
                          "
                        >
                          <el-select
                            v-model="formData.source"
                            placeholder="请选择活动区域"
                            @change="sourceChange"
                          >
                            <el-option label="工序模版" :value="0"></el-option>
                            <el-option
                              label="投料模版"
                              :value="1"
                              v-if="!formData.type"
                            ></el-option>
                            <el-option
                              label="绑码列表"
                              :value="2"
                              v-if="formData.type == 1"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="绑码时间筛选"
                          v-if="formData.source == 2"
                        >
                          <el-date-picker
                            v-model="timeValue1"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          :label="
                            [
                              '投料数据',
                              ['投料数据', '产出数据', '损耗数据'][
                                formData.type
                              ],
                              '绑码批次',
                            ][formData.source]
                          "
                        >
                          <el-select
                            v-model="formData.sourceId"
                            placeholder="请选择"
                            @visible-change="openSelect"
                            @change="selectChange"
                            :loading="dataLoading"
                          >
                            <template v-if="formData.source !== 2">
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </template>
                            <template v-else>
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                                <span style="float: left">{{
                                  item.goodsName
                                }}</span>
                                <span
                                  style="
                                    float: right;
                                    color: #8492a6;
                                    font-size: 13px;
                                  "
                                  >{{ item.label }}</span
                                >
                              </el-option>
                            </template>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            formData.type ? '是否计入总产出' : '是否计入总投料'
                          "
                          v-if="![2, 5].includes(formData.type)"
                        >
                          <div class="df aic">
                            <el-switch v-model="formData.isTotal"></el-switch>
                          </div>
                        </el-form-item>
                      </template>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="handleAdd"
                          v-if="editId === null"
                          >提交</el-button
                        >
                        <el-button type="primary" @click="handleEdit" v-else
                          >修改</el-button
                        >
                        <el-button
                          @click="showAdd = false"
                          style="margin-left: 10px"
                          >取消</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="产出损耗列表" name="产出损耗列表">
              <div class="df fdr" style="width: 100%; gap: 10px; height: 100%">
                <div
                  class="cover df fdc"
                  style="
                    flex: 2;
                    width: 0;
                    height: 100%;
                    background-color: #f8f8f8;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button
                      slot="reference"
                      size="small"
                      type="primary"
                      @click="openAdd(5)"
                      >新增产出损耗</el-button
                    >
                  </div>
                  <div class="" style="flex: 1; height: 0">
                    <div class="cover" style="overflow: auto; padding: 10px">
                      <div class="modal-body">
                        <div
                          class="material-card"
                          v-for="item in lossList2"
                          :key="item.id"
                        >
                          <div class="material-header">
                            <h3 class="material-name">{{ item.name }}</h3>
                          </div>
                          <div class="material-content">
                            <div class="info-item">
                              <div class="info-label">产出损耗量</div>
                              <div class="highlight-value">
                                {{ item.data }}kg
                              </div>
                            </div>
                          </div>
                          <div class="material-actions">
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              style="margin-left: 10px"
                              @click="editItem(item)"
                              >修改</el-button
                            >
                            <el-button
                              type="text"
                              class="disib"
                              size="mini"
                              @click="handleDel(item)"
                              style="margin-left: 10px; color: #f56c6c"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showAdd"
                  class="cover df fdc"
                  style="
                    flex: 1;
                    width: 0;
                    height: 100%;
                    background-color: #fff;
                    border-radius: 5px;
                    padding: 30px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                  "
                >
                  <div>
                    <div class="df aic jcc" style="margin-bottom: 10px">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "新增" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <template v-if="[0, 1, 2, 5].includes(formData.type)">
                        <el-form-item
                          :label="formData.type ? '产出名称' : '投料名称'"
                        >
                          <el-input v-model="formData.name"></el-input>
                        </el-form-item>

                        <el-form-item label="类型">
                          <el-select
                            v-model="formData.type"
                            placeholder="请选择活动区域"
                            @change="typeChange"
                          >
                            <el-option label="投入" :value="0"></el-option>
                            <el-option label="产出" :value="1"></el-option>
                            <el-option label="原料损耗" :value="2"></el-option>
                            <el-option label="产出损耗" :value="5"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            ['投料来源', '产出来源', '损耗来源'][formData.type]
                          "
                        >
                          <el-select
                            v-model="formData.source"
                            placeholder="请选择活动区域"
                            @change="sourceChange"
                          >
                            <el-option label="工序模版" :value="0"></el-option>
                            <el-option
                              label="投料模版"
                              :value="1"
                              v-if="!formData.type"
                            ></el-option>
                            <el-option
                              label="绑码列表"
                              :value="2"
                              v-if="formData.type == 1"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="绑码时间筛选"
                          v-if="formData.source == 2"
                        >
                          <el-date-picker
                            v-model="timeValue1"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          :label="
                            [
                              '投料数据',
                              ['投料数据', '产出数据', '损耗数据'][
                                formData.type
                              ],
                              '绑码批次',
                            ][formData.source]
                          "
                        >
                          <el-select
                            v-model="formData.sourceId"
                            placeholder="请选择"
                            @visible-change="openSelect"
                            @change="selectChange"
                            :loading="dataLoading"
                          >
                            <template v-if="formData.source !== 2">
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </template>
                            <template v-else>
                              <el-option
                                v-for="item in dataList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                                <span style="float: left">{{
                                  item.goodsName
                                }}</span>
                                <span
                                  style="
                                    float: right;
                                    color: #8492a6;
                                    font-size: 13px;
                                  "
                                  >{{ item.label }}</span
                                >
                              </el-option>
                            </template>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          :label="
                            formData.type ? '是否计入总产出' : '是否计入总投料'
                          "
                          v-if="![2, 5].includes(formData.type)"
                        >
                          <div class="df aic">
                            <el-switch v-model="formData.isTotal"></el-switch>
                          </div>
                        </el-form-item>
                      </template>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="handleAdd"
                          v-if="editId === null"
                          >提交</el-button
                        >
                        <el-button type="primary" @click="handleEdit" v-else
                          >修改</el-button
                        >
                        <el-button
                          @click="showAdd = false"
                          style="margin-left: 10px"
                          >取消</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="工序物料平衡"
      :visible.sync="popupVisible"
      width="1200px"
      custom-class="daily-box"
      @closed="popupClose"
    >
      <div class="df" style="background-color: #eee; gap: 10px">
        <div
          class="df"
          style="
            flex: 1;
            gap: 10px;
            height: 900px;
            flex-direction: column;
            transition: transform 250ms, opacity 400ms;
          "
        >
          <div
            class="record-box df"
            style="
              height: 100px;
              overflow: auto;
              box-sizing: border-box;
              gap: 10px;
              flex-direction: row;
            "
          >
            <div
              style="
                flex: 1;
                width: 0;
                height: 100%;
                border-radius: 10px;
                padding: 10px 20px;
                overflow: hidden;
                background-color: #fff;
              "
            >
              <div
                class="df aic jcc stat-value"
                style="color: #8980c1; font-size: 34px"
              >
                {{ procedureRate }}%
              </div>
              <div class="df aic jcc" style="font-size: 14px; color: #909399">
                工序得率
              </div>
            </div>
            <div
              style="
                flex: 1;
                width: 0;
                height: 100%;
                border-radius: 10px;
                overflow: hidden;
                padding: 10px 20px;
                background-color: #fff;
              "
            >
              <div
                class="df aic jcc stat-value"
                style="color: #d6a799; font-size: 34px"
              >
                <span v-if="theoryProcedureRate.id">
                  {{ theoryProcedureRate.value }}%
                </span>
                <span v-else> 未配置 </span>
              </div>
              <div class="df aic jcb" style="font-size: 14px; color: #909399">
                <div style="flex: 1"></div>
                <div style="flex: 2">工序理论得率</div>
                <el-popover
                  placement="bottom"
                  width="400"
                  trigger="click"
                  v-model="showAdd2"
                  @show="openPopover2"
                  @hide="showAdd2 = false"
                >
                  <div style="padding: 20px 20px 0">
                    <div class="df aic jcc">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "配置" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <el-form-item label="理论损耗率">
                        <el-input
                          placeholder="请输入理论损耗率"
                          v-model="formData.dataInfo"
                          type="number"
                          clearable
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <div class="df aic jcc">
                          <el-button
                            type="primary"
                            @click="handleAdd"
                            v-if="theoryLossRate.id === null"
                            >提交</el-button
                          >
                          <el-button type="primary" @click="handleEdit1" v-else
                            >修改</el-button
                          >
                          <el-button
                            @click="showAdd2 = false"
                            style="margin-left: 10px"
                            >取消</el-button
                          >
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>

                  <div
                    slot="reference"
                    style="color: #409eff; gap: 5px; flex: 1"
                  >
                    <div class="df aic pointer">
                      去配置<i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div
            class="record-box df"
            style="
              height: 100px;
              overflow: auto;
              box-sizing: border-box;
              gap: 10px;
              flex-direction: row;
            "
          >
            <div
              style="
                flex: 1;
                width: 0;
                height: 100%;
                border-radius: 10px;
                padding: 10px 20px;
                overflow: hidden;
                background-color: #fff;
              "
            >
              <div
                class="df aic jcc stat-value"
                style="color: #8980c1; font-size: 34px"
              >
                {{ lossRateData }}%
              </div>
              <div class="df aic jcc" style="font-size: 14px; color: #909399">
                工序损耗率
              </div>
            </div>
            <div
              style="
                flex: 1;
                width: 0;
                height: 100%;
                border-radius: 10px;
                overflow: hidden;
                padding: 10px 20px;
                background-color: #fff;
              "
            >
              <div
                class="df aic jcc stat-value"
                style="color: #d6a799; font-size: 34px"
              >
                <span v-if="theoryLossRate.id">
                  {{ theoryLossRate.value }}%
                </span>
                <span v-else> 未配置 </span>
              </div>
              <div class="df aic jcb" style="font-size: 14px; color: #909399">
                <div style="flex: 1"></div>
                <div style="flex: 2">工序理论损耗率</div>
                <el-popover
                  placement="bottom"
                  width="400"
                  trigger="click"
                  v-model="showAdd1"
                  @show="openPopover1"
                  @hide="showAdd1 = false"
                >
                  <div style="padding: 20px 20px 0">
                    <div class="df aic jcc">
                      <span class="special-title" style="margin-bottom: 10px">
                        {{ editId === null ? "配置" : "修改" }}
                      </span>
                    </div>

                    <el-form
                      ref="form"
                      :model="formData"
                      label-width="120px"
                      label-position="left"
                    >
                      <el-form-item label="理论损耗率">
                        <el-input
                          placeholder="请输入理论损耗率"
                          v-model="formData.dataInfo"
                          type="number"
                          clearable
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <div class="df aic jcc">
                          <el-button
                            type="primary"
                            @click="handleAdd"
                            v-if="theoryLossRate.id === null"
                            >提交</el-button
                          >
                          <el-button type="primary" @click="handleEdit1" v-else
                            >修改</el-button
                          >
                          <el-button
                            @click="showAdd1 = false"
                            style="margin-left: 10px"
                            >取消</el-button
                          >
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>

                  <div
                    slot="reference"
                    style="color: #409eff; gap: 5px; flex: 1"
                  >
                    <div class="df aic pointer">
                      去配置<i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div
            class="record-box"
            style="
              flex: 1;
              height: 0;
              overflow: auto;
              border-radius: 10px;
              padding: 20px;
              background-color: #fff;
              box-sizing: border-box;
            "
          >
            <div style="flex: 1">
              <el-tabs
                v-model="activeName"
                @tab-click="
                  showConfig = false;
                  showAdd = false;
                "
              >
                <el-tab-pane label="投料列表" name="first">
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button size="small" type="primary" @click="openAdd(0)"
                      >新增投料</el-button
                    >
                  </div>
                  <el-table :data="inputList" style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="投料名称"
                      width="180"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="data"
                      label="投料量"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          style="color: #e6a23c"
                          @click="openConfig(scope)"
                          >理论产量</el-button
                        >
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          style="margin-left: 10px"
                          @click="editItem(scope.row)"
                          >修改</el-button
                        >
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          @click="handleDel(scope.row)"
                          style="margin-left: 10px; color: #f56c6c"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="产出列表" name="second">
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button size="small" type="primary" @click="openAdd(1)"
                      >新增产出</el-button
                    >
                  </div>
                  <el-table :data="outputList" style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="产出名称"
                      width="180"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="data"
                      label="产出量"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          @click="editItem(scope.row)"
                          >修改</el-button
                        >
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          @click="handleDel(scope.row)"
                          style="margin-left: 10px; color: #f56c6c"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="损耗列表" name="third">
                  <div
                    class="df"
                    style="padding: 0 10px 10px; justify-content: flex-end"
                  >
                    <el-button size="small" type="primary" @click="openAdd(2)"
                      >新增损耗</el-button
                    >
                  </div>
                  <el-table :data="lossList" style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="损耗名称"
                      width="180"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="data"
                      label="消耗量"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          style="margin-left: 10px"
                          @click="editItem(scope.row)"
                          >修改</el-button
                        >
                        <el-button
                          type="text"
                          class="disib"
                          size="mini"
                          @click="handleDel(scope.row)"
                          style="margin-left: 10px; color: #f56c6c"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div
            class="record-box"
            style="
              overflow: hidden;
              border-radius: 10px;
              background-color: #fff;
              flex: 1;
              height: 0;
            "
            v-if="showConfig"
          >
            <div
              class="df"
              style="flex-direction: column; height: 100%; width: 100%"
            >
              <div
                class="df aic jcb pointer"
                style="width: 100%; padding: 20px 20px 0"
              >
                <div></div>
                <span class="special-title">每100kg理论产量</span>
                <div>
                  <i
                    @click="showConfig = false"
                    class="el-icon-close"
                    style="font-size: 24px; color: #90399"
                  ></i>
                </div>
              </div>
              <div
                style="flex: 1; width: 100%; height: 0; overflow: auto"
                class="scroll-box"
              >
                <div style="width: 100%; padding: 0 20px 20px">
                  <el-table :data="outputList" style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="产出名称"
                      width="140"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="data"
                      label="每100kg理论产量"
                      width="120"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <div
                          v-if="
                            theoreticalList[checkedIndex][scope.$index].isEdit
                          "
                        >
                          <el-input
                            placeholder="请输入理论产量"
                            v-model="
                              theoreticalList[checkedIndex][scope.$index]
                                .theoretical
                            "
                          >
                            <template slot="append">kg</template>
                          </el-input>
                        </div>
                        <div v-else class="df aic jcc">
                          <span
                            v-if="
                              inputList[checkedIndex].theoretical &&
                              JSON.parse(inputList[checkedIndex].theoretical)
                                .length &&
                              JSON.parse(
                                inputList[checkedIndex].theoretical
                              ).filter((tItem) => tItem.id === scope.row.id)
                                .length
                            "
                          >
                            {{
                              JSON.parse(
                                inputList[checkedIndex].theoretical
                              ).filter((tItem) => tItem.id === scope.row.id)[0]
                                .theoretical
                            }}kg
                          </span>
                          <span v-else style="color: #909399">
                            未理论产量配置，请先进行配置
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="100"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <div
                          class="df aic jcc"
                          style="gap: 8px"
                          v-if="
                            theoreticalList[checkedIndex][scope.$index].isEdit
                          "
                        >
                          <el-button
                            size="mini"
                            type="success"
                            @click="editTheoretical(checkedIndex, scope.$index)"
                          >
                            完成
                          </el-button>
                          <el-button
                            size="mini"
                            type="primary"
                            style="margin: 0"
                            @click="
                              changeEditFlag(checkedIndex, scope.$index, false)
                            "
                          >
                            取消
                          </el-button>
                        </div>
                        <div v-else class="df aic jcc">
                          <el-button
                            size="mini"
                            type="primary"
                            @click="
                              changeEditFlag(checkedIndex, scope.$index, true)
                            "
                          >
                            配置
                          </el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div
            class="record-box"
            style="
              overflow: auto;
              border-radius: 10px;
              padding: 20px;
              background-color: #fff;
            "
            v-if="showAdd"
          >
            <span class="special-title" style="margin-bottom: 10px">{{
              editId === null
                ? [3.4].includes(formData.type)
                  ? "配置"
                  : "新增"
                : "修改"
            }}</span>

            <el-form
              ref="form"
              :model="formData"
              label-width="120px"
              label-position="left"
            >
              <template v-if="[0, 1, 2].includes(formData.type)">
                <el-form-item :label="formData.type ? '产出名称' : '投料名称'">
                  <el-input v-model="formData.name"></el-input>
                </el-form-item>

                <el-form-item label="类型">
                  <el-select
                    v-model="formData.type"
                    placeholder="请选择活动区域"
                    @change="typeChange"
                  >
                    <el-option label="投入" :value="0"></el-option>
                    <el-option label="产出" :value="1"></el-option>
                    <el-option label="损耗" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="['投料来源', '产出来源', '损耗来源'][formData.type]"
                >
                  <el-select
                    v-model="formData.source"
                    placeholder="请选择活动区域"
                    @change="sourceChange"
                  >
                    <el-option label="工序模版" :value="0"></el-option>
                    <el-option
                      label="投料模版"
                      :value="1"
                      v-if="!formData.type"
                    ></el-option>
                    <el-option
                      label="绑码列表"
                      :value="2"
                      v-if="formData.type == 1"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="绑码时间筛选" v-if="formData.source == 2">
                  <el-date-picker
                    v-model="timeValue1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  :label="
                    [
                      '投料数据',
                      ['投料数据', '产出数据', '损耗数据'][formData.type],
                      '绑码批次',
                    ][formData.source]
                  "
                >
                  <el-select
                    v-model="formData.sourceId"
                    placeholder="请选择"
                    @visible-change="openSelect"
                    @change="selectChange"
                    :loading="dataLoading"
                  >
                    <template v-if="formData.source !== 2">
                      <el-option
                        v-for="item in dataList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </template>
                    <template v-else>
                      <el-option
                        v-for="item in dataList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.goodsName }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                          >{{ item.label }}</span
                        >
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="formData.type ? '是否计入总产出' : '是否计入总投料'"
                  v-if="formData.type != 2"
                >
                  <div class="df aic">
                    <el-switch v-model="formData.isTotal"></el-switch>
                  </div>
                </el-form-item>
              </template>
              <el-form-item v-else-if="formData.type == 3" label="理论得率">
                <el-input
                  placeholder="请输入理论得率"
                  v-model="formData.dataInfo"
                  type="number"
                  clearable
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
              <el-form-item v-else-if="formData.type == 4" label="理论得率">
                <el-input
                  placeholder="请输入理论得率"
                  v-model="formData.dataInfo"
                  type="number"
                  clearable
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <template v-if="[0, 1, , 2].includes(formData.type)">
                  <el-button
                    type="primary"
                    @click="handleAdd"
                    v-if="editId === null"
                    >提交</el-button
                  >
                  <el-button type="primary" @click="handleEdit" v-else
                    >修改</el-button
                  >
                </template>
                <template v-else-if="formData.type == 3">
                  <el-button
                    type="primary"
                    @click="handleAdd"
                    v-if="theoryProcedureRate.id === null"
                    >提交</el-button
                  >
                  <el-button type="primary" @click="handleEdit1" v-else
                    >修改</el-button
                  >
                </template>

                <template v-else-if="formData.type == 4">
                  <el-button
                    type="primary"
                    @click="handleAdd"
                    v-if="theoryLossRate.id === null"
                    >提交</el-button
                  >
                  <el-button type="primary" @click="handleEdit1" v-else
                    >修改</el-button
                  >
                </template>

                <el-button @click="showAdd = false" style="margin-left: 10px"
                  >取消</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div
          class="df"
          style="flex: 1; flex-direction: column; height: 900px; gap: 10px"
        >
          <div
            class="record-box df"
            style="
              flex: 1;
              height: 0;
              overflow: auto;
              border-radius: 10px;
              padding: 20px;
              background-color: #fff;
              flex-direction: column;
            "
          >
            <div>
              <span class="special-title">转化率分析</span>
            </div>
            <div
              style="height: 80px; width: 440px; flex-direction: row"
              class="df aic"
            >
              <div class="filter-label" style="width: 50px; margin-right: 10px">
                筛选:
              </div>
              <div style="flex: 1; width: 0">
                <el-date-picker
                  size="small"
                  v-model="timeValue2"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="timeChange(0)"
                >
                </el-date-picker>
              </div>
            </div>
            <div
              style="flex: 1; height: 0; width: 100%"
              v-loading="inversionLoading"
            >
              <div
                style="
                  width: 100%;
                  height: 100%;
                  background-color: #f5f7fa;
                  border-radius: 10px;
                "
              >
                <Charts3
                  :dataList="inversionList"
                  v-if="!inversionLoading && inversionList.length"
                  :type="0"
                />
                <el-empty
                  description="无相关数据"
                  v-else-if="!inversionLoading && !inversionList.length"
                ></el-empty>
              </div>
            </div>
          </div>
          <div
            class="record-box df"
            style="
              flex: 1;
              height: 0;
              overflow: auto;
              border-radius: 10px;
              padding: 20px;
              background-color: #fff;
              flex-direction: column;
            "
          >
            <div>
              <span class="special-title">损耗率分析</span>
            </div>
            <div
              style="height: 80px; width: 440px; flex-direction: row"
              class="df aic"
            >
              <div class="filter-label" style="width: 50px; margin-right: 10px">
                筛选:
              </div>
              <div style="flex: 1; width: 0">
                <el-date-picker
                  size="small"
                  v-model="timeValue3"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="timeChange(1)"
                >
                </el-date-picker>
              </div>
            </div>
            <div
              style="flex: 1; height: 0; width: 100%"
              v-loading="lossLoading"
            >
              <div
                style="
                  width: 100%;
                  height: 100%;
                  background-color: #f5f7fa;
                  border-radius: 10px;
                "
              >
                <Charts3
                  :dataList="lossList1"
                  v-if="!lossLoading && lossList1.length"
                  :type="1"
                />
                <el-empty
                  description="无相关数据"
                  v-else-if="!lossLoading && !lossList1.length"
                ></el-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import api from "@/util/extra-api";
import axios from "@/util/api";
import StepItem from "./NewStepItem.vue";
import Charts3 from "./charts3.vue";
import Charts4 from "./charts4.vue";
import { get } from "jquery";

export default {
  name: "CustomStep",
  components: {
    StepItem,
    Charts3,
    Charts4,
  },
  props: {
    stepsData: {
      type: Array,
      default() {
        return [];
      },
    },
    productionLineId: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    stepsData: {
      handler(newVal) {
        if (this.popupVisible && this.formData.otherId) {
          this.refreshPopupData();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      showCharts: false,
      cellWidth: 220,
      centerWidth: 180,
      cellHeight: 300,
      centerHeight: 248,
      cellConunt: 5,
      pointWidth: 36,
      lineWidth: 4,
      clientWidth: 1200,
      showInfo: false,
      traceList: [],
      popupVisible: false,
      formData: {
        name: "",
        type: 1,
        source: 0,
        sourceId: null,
        otherId: null,
        dataInfo: null,
        companyId: null,
        theoretical: null,
        goodsId: null,
        goodsName: "",
        batchNumber: "",
        isTotal: false,
      },
      dataLoading: false,
      dataList: [],
      companyId: null,
      timeValue1: null,
      inputList: [],
      outputList: [],
      editId: null,
      activeName: "first",
      theoreticalList: [],
      timeValue2: [],
      timeValue3: [],
      inversionList: [],
      inversionLoading: false,
      lossLoading: false,
      lossList: [],
      lossList1: [],
      lossList2: [],
      showAdd: false,
      showAdd1: false,
      showAdd2: false,
      showAdd3: false,
      showConfig: false,
      checkedIndex: null,
      procedureRate: null,
      theoryProcedureRate: {
        value: 0,
        id: null,
      },
      theoryLossRate1: {
        value: 0,
        id: null,
      },
      theoryLossRate: {
        value: 0,
        id: null,
      },
      lossRateData: null,
      tabsValue: "批次变化趋势",
      outputLossRate: "",
      utilizationData: [],
    };
  },
  mounted() {
    this.companyId = Number(localStorage.getItem("company_id"));
    this.formData.companyId = this.companyId;
    this.clientWidth = this.$refs.container.clientWidth;
    this.$set(this, "showAdd1", false);
    this.$set(this, "showAdd2", false);

    // console.log(this.cellWidth * (this.cellConunt + 1), "width");
  },
  methods: {
    getUtilizationData(id) {
      api
        .get("/v1/wx/companyMaterial/utilizationData", {
          id,
          productionLineId: this.productionLineId,
          startTime: "",
          endTime: "",
          finishedTag: "",
        })
        .then((res) => {
          if (res.code === 200) {
            this.showCharts = true;
            this.utilizationData = res.data;
            this.showConfig = false;
            this.showAdd = false;
          }
        });
    },
    openPopover3() {
      this.editId = this.theoryLossRate1.id;
      this.formData.dataInfo = this.theoryLossRate1.value;
      this.formData.name = "理论产出损耗率";
      this.formData.type = 6;
    },
    openPopover2() {
      this.editId = this.theoryProcedureRate.id;
      this.formData.dataInfo = this.theoryProcedureRate.value;
      this.formData.name = "理论得率";
      this.formData.type = 3;
    },
    openPopover1() {
      this.editId = this.theoryLossRate.id;
      this.formData.dataInfo = this.theoryLossRate.value;
      this.formData.name = "理论原料损耗率";
      this.formData.type = 4;
    },
    openPopover0() {
      this.formData = {
        name: "",
        type: type,
        source: 0,
        sourceId: null,
        otherId: this.formData.otherId,
        dataInfo: null,
        companyId: this.companyId,
        theoretical: null,
        goodsId: null,
        goodsName: "",
        batchNumber: "",
        isTotal: false,
      };
      this.showConfig = false;
    },
    openConfig(index) {
      this.checkedIndex = index;
      this.showConfig = true;
      this.showCharts = false;
      this.showAdd = false;
    },
    openAdd(type) {
      this.formData = {
        name: "",
        type: type,
        source: 0,
        sourceId: null,
        otherId: this.formData.otherId,
        dataInfo: null,
        companyId: this.companyId,
        theoretical: null,
        goodsId: null,
        goodsName: "",
        batchNumber: "",
        isTotal: false,
      };
      this.editId = null;
      this.showAdd = true;
      this.showConfig = false;
      this.showCharts = false;
    },
    timeChange(type) {
      this.conversionRate(this.formData.otherId, type);
    },
    conversionRate(id, type) {
      let data = {
        companyId: this.companyId,
        startTime: "",
        endTime: "",
        productionLineId: this.productionLineId,
        stepId: id,
        type,
      };
      if (type === 0) {
        if (this.timeValue2) {
          data.startTime = this.timeValue2[0];
          data.endTime = this.timeValue2[1];
        }
        this.inversionLoading = true;
      } else {
        if (this.timeValue3) {
          data.startTime = this.timeValue3[0];
          data.endTime = this.timeValue3[1];
        }
        this.lossLoading = true;
      }

      api.get("/v1/wx/companyMaterial/conversionRate", data).then((res) => {
        if (res.code === 200) {
          if (type === 0) {
            this.inversionList = res.data;
            setTimeout(() => {
              this.inversionLoading = false;
            }, 1000);
          } else {
            this.lossList1 = res.data;
            setTimeout(() => {
              this.lossLoading = false;
            }, 1000);
          }
        }
      });
    },
    editTheoretical(index, oIndex) {
      let row = this.inputList[index];
      let id = this.theoreticalList[index][oIndex].id;

      this.editId = row.id;
      this.formData.name = row.name;
      this.formData.type = row.type;
      this.formData.source = row.source;
      this.formData.sourceId = row.sourceId;
      this.formData.otherId = row.otherId;
      this.formData.dataInfo = row.dataInfo;
      this.formData.companyId = row.companyId;
      this.formData.theoretical = row.theoretical;
      this.formData.goodsId = row.goodsId;
      this.formData.goodsName = row.goodsName;
      this.formData.batchNumber = row.batchNumber;
      this.formData.isTotal = row.isTotal;

      if (
        !this.formData.theoretical ||
        !JSON.parse(this.formData.theoretical).length
      ) {
        this.formData.theoretical = JSON.stringify([
          {
            id,
            theoretical: this.theoreticalList[index][oIndex].theoretical,
            name: this.theoreticalList[index][oIndex].name,
          },
        ]);
      } else if (
        !JSON.parse(this.formData.theoretical).filter((v) => v.id == id).length
      ) {
        let theoretical = JSON.parse(this.formData.theoretical);
        theoretical.push({
          id,
          name: this.theoreticalList[index][oIndex].name,
          theoretical: this.theoreticalList[index][oIndex].theoretical,
        });
        this.formData.theoretical = JSON.stringify(theoretical);
      } else {
        let theoretical = JSON.parse(this.formData.theoretical);
        theoretical.filter((v) => v.id == id)[0].theoretical =
          this.theoreticalList[index][oIndex].theoretical;
        this.formData.theoretical = JSON.stringify(theoretical);
      }

      this.handleEdit();
    },
    changeEditFlag(index, oIndex, data) {
      if (
        data &&
        this.inputList[index].theoretical &&
        JSON.parse(this.inputList[index].theoretical).filter(
          (v) => v.id == this.outputList[oIndex].id
        ).length
      ) {
        this.theoreticalList[index][oIndex].theoretical = JSON.parse(
          this.inputList[index].theoretical
        ).filter((v) => v.id == this.outputList[oIndex].id)[0].theoretical;
      }
      this.theoreticalList[index][oIndex].isEdit = data;
    },
    handleDel(row) {
      api
        .post("/v1/wx/companyMaterial/deleteSourceInfo", { id: row.id })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
            this.$emit("update");
          }
        });
    },
    handleEdit1() {
      api
        .post("/v1/wx/companyMaterial/addSourceInfo", {
          ...this.formData,
          id: this.theoryProcedureRate.id,
          productionLineId: this.productionLineId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });

            this.$emit("update");
            if (this.showAdd1) {
              this.showAdd1 = false;
            } else if (this.showAdd2) {
              this.showAdd2 = false;
            }
          }
        });
    },
    handleEdit() {
      api
        .post("/v1/wx/companyMaterial/updateSourceInfo", {
          ...this.formData,
          id: this.editId,
          productionLineId: this.productionLineId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.$emit("update");
            this.showAdd = false;
            this.editId = null;
          }
        });
    },
    editItem(row) {
      let query = {
        companyId: this.companyId,
        type: row.type,
        source: row.source,
        productionLineId: this.productionLineId,
      };
      if (this.timeValue1) {
        query.startTime = this.timeValue1[0];
        query.endTime = this.timeValue1[1];
      }
      api.get("/v1/wx/companyMaterial/getDataList", query).then((res) => {
        console.log(this.formData.source);

        this.dataList = res.data.map((v) => {
          if (row.source == 1) {
            return {
              value: v.id,
              label: v.templateName,
            };
          } else if (row.source == 0) {
            return {
              value: v.id,
              label: v.name,
            };
          } else {
            return {
              value: v.id,
              label: v.batchNumber,
              goodsName: v.goodsName,
              goodsId: v.goodsId,
            };
          }
        });
        this.dataLoading = false;
        this.editId = row.id;
        this.formData.name = row.name;
        this.formData.type = row.type;
        this.formData.source = row.source;
        this.formData.sourceId = row.sourceId;
        this.formData.otherId = row.otherId;
        this.formData.dataInfo = row.dataInfo;
        this.formData.companyId = row.companyId;
        this.formData.theoretical = row.theoretical;
        this.formData.goodsId = row.goodsId;
        this.formData.goodsName = row.goodsName;
        this.formData.batchNumber = row.batchNumber;
        this.formData.isTotal = row.isTotal;
        this.showAdd = true;
        this.showConfig = false;
        this.showCharts = false;
      });
    },
    openPopup(item, dataItem) {
      this.conversionRate(
        this.stepsData[(item - 1) * this.cellConunt + dataItem - 1].stepId,
        0
      );
      this.conversionRate(
        this.stepsData[(item - 1) * this.cellConunt + dataItem - 1].stepId,
        1
      );
      api
        .get("/v1/wx/companyMaterial/getSourceList", {
          otherId:
            this.stepsData[(item - 1) * this.cellConunt + dataItem - 1].stepId,
          companyId: this.companyId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.procedureRate =
              this.stepsData[
                (item - 1) * this.cellConunt + dataItem - 1
              ].balanceRate;
            this.lossRateData =
              this.stepsData[
                (item - 1) * this.cellConunt + dataItem - 1
              ].lossRate;
            this.outputLossRate =
              this.stepsData[
                (item - 1) * this.cellConunt + dataItem - 1
              ].outputLossRate;
            if (res.data.length && res.data.filter((v) => v.type == 3).length) {
              this.theoryProcedureRate.id = res.data.filter(
                (v) => v.type == 3
              )[0].id;
              this.theoryProcedureRate.value = res.data.filter(
                (v) => v.type == 3
              )[0].dataInfo;
            } else {
              this.theoryProcedureRate.id = null;
              this.theoryProcedureRate.value = 0;
            }
            if (res.data.length && res.data.filter((v) => v.type == 4).length) {
              this.theoryLossRate.id = res.data.filter(
                (v) => v.type == 4
              )[0].id;
              this.theoryLossRate.value = res.data.filter(
                (v) => v.type == 4
              )[0].dataInfo;
            } else {
              this.theoryLossRate.id = null;
              this.theoryLossRate.value = 0;
            }
            if (res.data.length && res.data.filter((v) => v.type == 6).length) {
              this.theoryLossRate1.id = res.data.filter(
                (v) => v.type == 6
              )[0].id;
              this.theoryLossRate1.value = res.data.filter(
                (v) => v.type == 6
              )[0].dataInfo;
            } else {
              this.theoryLossRate1.id = null;
              this.theoryLossRate1.value = 0;
            }

            this.formData.otherId =
              this.stepsData[
                (item - 1) * this.cellConunt + dataItem - 1
              ].stepId;
            this.inputList = res.data
              .filter((v) => v.type == 0)
              .map((v) => {
                return {
                  ...v,
                  data: (() => {
                    const matched = this.stepsData[
                      (item - 1) * this.cellConunt + dataItem - 1
                    ].dataList.find((dItem) => dItem.id === v.id);
                    return matched ? matched.data : v.data;
                  })(),
                  editFlag: [],
                  utilization: (() => {
                    const matched = this.stepsData[
                      (item - 1) * this.cellConunt + dataItem - 1
                    ].dataList.find((dItem) => dItem.id === v.id);
                    return matched ? matched.utilization : null;
                  })(),
                };
              });
            this.inputList.forEach((v, i) => {
              this.theoreticalList.push([]);
              res.data
                .filter((v) => v.type == 1)
                .forEach((v1) => {
                  this.theoreticalList[i].push({
                    id: v1.id,
                    isEdit: false,
                    theoretical: !v.theoretical
                      ? ""
                      : !JSON.parse(v.theoretical).filter(
                          (v2) => v2.id == v1.id
                        ).length
                      ? ""
                      : JSON.parse(v.theoretical).filter(
                          (v2) => v2.id == v1.id
                        )[0].theoretical,
                  });
                });
            });
            this.outputList = res.data
              .filter((v) => v.type == 1)
              .map((v) => {
                const matched = this.stepsData[
                  (item - 1) * this.cellConunt + dataItem - 1
                ].dataList.find((dItem) => dItem.id === v.id);
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
            this.lossList = res.data
              .filter((v) => v.type == 2)
              .map((v) => {
                const matched = this.stepsData[
                  (item - 1) * this.cellConunt + dataItem - 1
                ].dataList.find((dItem) => dItem.id === v.id);
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
            this.lossList2 = res.data
              .filter((v) => v.type == 5)
              .map((v) => {
                const matched = this.stepsData[
                  (item - 1) * this.cellConunt + dataItem - 1
                ].dataList.find((dItem) => dItem.id === v.id);
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
            this.showAdd = false;
            this.popupVisible = true;
          }
        });
    },
    isEnd(item, dataItem) {
      return {
        bottom:
          (item - 1) * this.cellConunt + dataItem === this.stepsData.length &&
          dataItem == this.cellConunt,
        left:
          (item - 1) * this.cellConunt + dataItem === this.stepsData.length &&
          item % 2 != 1 &&
          dataItem != this.cellConunt,
        right:
          (item - 1) * this.cellConunt + dataItem === this.stepsData.length &&
          item % 2 == 1 &&
          dataItem != this.cellConunt,
      };
    },
    popupClose() {
      this.formData = {
        name: "",
        type: 1,
        source: 0,
        sourceId: null,
        otherId: this.formData.otherId,
        dataInfo: null,
        companyId: this.companyId,
        theoretical: null,
        goodsId: null,
        goodsName: "",
        batchNumber: "",
        isTotal: false,
      };
      this.editId = null;
      this.tabsValue = "批次变化趋势";
      this.showConfig = false;
    },
    refreshPopupData() {
      if (!this.formData.otherId) return;
      api
        .get("/v1/wx/companyMaterial/getSourceList", {
          otherId: this.formData.otherId,
          companyId: this.companyId,
        })
        .then((res) => {
          if (res.code === 200) {
            const stepData = this.stepsData.find(
              (s) => s.stepId === this.formData.otherId
            );
            if (stepData) {
              this.procedureRate = stepData.balanceRate;
              this.lossRateData = stepData.lossRate;
              this.outputLossRate = stepData.outputLossRate;
            }
            if (res.data.length && res.data.filter((v) => v.type == 3).length) {
              this.theoryProcedureRate.id = res.data.filter(
                (v) => v.type == 3
              )[0].id;
              this.theoryProcedureRate.value = res.data.filter(
                (v) => v.type == 3
              )[0].dataInfo;
            } else {
              this.theoryProcedureRate.id = null;
              this.theoryProcedureRate.value = 0;
            }
            if (res.data.length && res.data.filter((v) => v.type == 4).length) {
              this.theoryLossRate.id = res.data.filter(
                (v) => v.type == 4
              )[0].id;
              this.theoryLossRate.value = res.data.filter(
                (v) => v.type == 4
              )[0].dataInfo;
            } else {
              this.theoryLossRate.id = null;
              this.theoryLossRate.value = 0;
            }
            if (res.data.length && res.data.filter((v) => v.type == 6).length) {
              this.theoryLossRate1.id = res.data.filter(
                (v) => v.type == 6
              )[0].id;
              this.theoryLossRate1.value = res.data.filter(
                (v) => v.type == 6
              )[0].dataInfo;
            } else {
              this.theoryLossRate1.id = null;
              this.theoryLossRate1.value = 0;
            }
            this.inputList = res.data
              .filter((v) => v.type == 0)
              .map((v) => {
                const matched = stepData?.dataList?.find(
                  (dItem) => dItem.id === v.id
                );
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                  editFlag: [],
                  utilization: matched ? matched.utilization : null,
                };
              });
            this.theoreticalList = [];
            this.inputList.forEach((v, i) => {
              this.theoreticalList.push([]);
              res.data
                .filter((v) => v.type == 1)
                .forEach((v1) => {
                  this.theoreticalList[i].push({
                    id: v1.id,
                    isEdit: false,
                    theoretical: !v.theoretical
                      ? ""
                      : !JSON.parse(v.theoretical).filter(
                          (tItem) => tItem.id === v1.id
                        ).length
                      ? ""
                      : JSON.parse(v.theoretical).filter(
                          (tItem) => tItem.id === v1.id
                        )[0].theoretical,
                  });
                });
            });
            this.outputList = res.data
              .filter((v) => v.type == 1)
              .map((v) => {
                const matched = stepData?.dataList?.find(
                  (dItem) => dItem.id === v.id
                );
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
            this.lossList = res.data
              .filter((v) => v.type == 2)
              .map((v) => {
                const matched = stepData?.dataList?.find(
                  (dItem) => dItem.id === v.id
                );
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
            this.lossList2 = res.data
              .filter((v) => v.type == 5)
              .map((v) => {
                const matched = stepData?.dataList?.find(
                  (dItem) => dItem.id === v.id
                );
                return {
                  ...v,
                  data: matched ? matched.data : v.data,
                };
              });
          }
        });
    },
    handleAdd() {
      api
        .post("/v1/wx/companyMaterial/addSourceInfo", {
          ...this.formData,
          productionLineId: this.productionLineId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success",
            });
            this.$emit("update");
            const currentType = this.formData.type;
            if (this.showAdd2) {
              this.showAdd2 = false;
            }
            if (this.showAdd1) {
              this.showAdd1 = false;
            }
            if (this.showAdd3) {
              this.showAdd3 = false;
            }
            if (this.showAdd) {
              this.formData = {
                name: "",
                type: currentType,
                source: 0,
                sourceId: null,
                otherId: this.formData.otherId,
                dataInfo: null,
                companyId: this.companyId,
                theoretical: null,
                goodsId: null,
                goodsName: "",
                batchNumber: "",
                isTotal: false,
              };
              this.editId = null;
              this.dataList = [];
            }
          }
        });
    },
    getDataList() {
      let query = {
        companyId: this.companyId,
        type: this.formData.type,
        source: this.formData.source,
        productionLineId: this.productionLineId,
      };
      if (this.timeValue1) {
        query.startTime = this.timeValue1[0];
        query.endTime = this.timeValue1[1];
      }
      api.get("/v1/wx/companyMaterial/getDataList", query).then((res) => {
        this.dataList = res.data.map((v) => {
          if (this.formData.source == 1) {
            return {
              value: v.id,
              label: v.templateName,
            };
          } else if (this.formData.source == 0) {
            return {
              value: v.id,
              label: v.name,
            };
          } else {
            return {
              value: v.id,
              label: v.batchNumber,
              goodsName: v.goodsName,
              goodsId: v.goodsId,
            };
          }
        });
        this.dataLoading = false;
      });
    },
    openSelect(val) {
      if (val) {
        this.dataList = [];
        this.dataLoading = true;
        this.getDataList();
      }
    },
    selectChange(value) {
      if (this.formData.source === 2) {
        let item = this.dataList.find((v) => v.value === value);
        if (item) {
          this.formData.goodsId = item.goodsId;
          this.formData.batchNumber = item.label;
          this.formData.goodsName = item.goodsName;
        }
      }
    },
    sourceChange(value) {
      this.formData.goodsId = null;
      this.formData.batchNumber = "";
      this.formData.goodsName = "";
      this.formData.sourceId = null;
    },
    typeChange(value) {
      if (value === 2) {
        this.formData.isTotal = true;
      } else {
        this.formData.isTotal = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.record-bg {
  background-image: url("../../../../assets/image/cool-background.png");
  overflow: hidden;
  border-radius: 20px;
  background-size: cover;
  z-index: 100;
  /*background-repeat: no-repeat;*/
}
.p50 {
  padding: 50px 20px !important;
  & > div {
    padding: 10px 0;
    border-top: 1px solid #7bbfea;
    display: flex;
    align-items: center;
  }
  &:last-child {
    padding: 0;
    border-bottom: 1px solid #7bbfea;
  }
}

$stark-light-blue: #00fffc;
$stark-med-blue: #00a4a2;
#fade-box {
  animation: form-entry 2s ease-in-out;
  /*background: #111;*/
  /*background: linear-gradient(#004746, #111);*/
  border: 1px solid $stark-med-blue;
  box-shadow: 0 0 15px #00fffd;
  border-radius: 20px;
  /*display: inline-block;*/
  /*height: 220px;*/
  /*margin: 200px auto 0;*/
  /*position: relative;*/
  z-index: 40;
  /*width: 500px;*/
  transition: 1s all;

  &:hover {
    border: 1px solid #00fffd;
    box-shadow: 0 0 25px #00fffd;
    transition: 1s all;
  }
}
@keyframes form-entry {
  0% {
    max-height: 80vh;
    width: 0;
    opacity: 0;
    padding: 0;
  }
  20% {
    max-height: 80vh;
    border: 4px solid $stark-med-blue;
    width: 0;
    opacity: 0;
    padding: 0;
  }

  40% {
    width: 0;
    max-height: 80vh;
    border: 4px solid $stark-med-blue;
    opacity: 1;
    padding: 0;
  }

  100% {
    max-height: 80vh;
    width: 800px;
  }
}
@keyframes input-entry {
  0% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.t-dialog {
  max-height: 70vh !important;
  overflow: scroll !important;
  width: 1200px !important;
}
.jcb {
  justify-content: space-between;
}
.more-box {
  padding: 5px 10px;
  border-radius: 8px;
}
.more-box:hover {
  background-color: #ededed;
}
.more-btn {
  width: 100%;
  padding: 5px 10px;
  // border-radius: 8px;
}
.more-btn:hover {
  background-color: #ededed;
}
.jcc {
  justify-content: center;
}
.mask-box {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.mask-container:hover .mask-box {
  display: flex;
}

/deep/.daily-box {
  height: 80vh;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .el-dialog__header {
    width: 100%;
  }
  .el-tabs__content {
    height: 100%;
  }
  .el-tab-pane {
    height: 100%;
  }
  .el-dialog__body {
    flex: 1;
    height: 0;
    width: 100%;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    background-color: #eee !important;
    padding: 20px !important;
  }
}

/deep/ .el-form-item__content {
  width: calc(100% - 120px) !important;
}

/deep/ .el-select {
  width: 100% !important;
}
/deep/.el-date-editor {
  width: 100% !important;
}
/deep/.el-range-separator {
  width: 9% !important;
}
/deep/.el-range-input {
  width: 37% !important;
}

.process-node {
  // width: 160px;
  // height: 220px;
  width: 100%;
  height: 100%;
  background: rgba(16, 18, 27, 0.8);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 12px 6px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.process-node:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  // border-color: rgba(0, 129, 255, 0.4);
}

.process-node.normal {
  border-top: 3px solid #36c17c;
}

.process-node.warning {
  border-top: 3px solid #fbc90d;
}

.process-node.critical {
  border-top: 3px solid #e9595d;
}

.process-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.process-name {
  font-size: 14px;
  font-weight: bold;
  color: #e1e1e1;
}

.process-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-normal {
  background-color: #36c17c;
  box-shadow: 0 0 6px #36c17c;
}

.status-warning {
  background-color: #fbc90d;
  box-shadow: 0 0 6px #fbc90d;
}

.status-critical {
  background-color: #e9595d;
  box-shadow: 0 0 6px #e9595d;
}

.process-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.process-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.section-title {
  font-size: 10px;
  color: #8f9bba;
  display: flex;
  align-items: center;
  gap: 4px;
}

.section-title i {
  font-size: 10px;
}

.product-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.product-item {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
}

.product-name {
  color: #a2c6ff;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-value {
  color: #e1e1e1;
  font-weight: 500;
}

.process-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.process-balance-box {
  padding-top: 6px;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.balance-label {
  font-size: 10px;
  color: #8f9bba;
}

.balance-value {
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 10px;
}
.process-node:hover::before {
  opacity: 1;
}

.special-title {
  position: relative;
  color: #409eff;
  font-size: 18px;
  display: inline-block;
  padding: 0 10px 5px 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.special-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, currentColor, transparent);
  border-radius: 2px;
}

.balance-good {
  background-color: rgba(54, 193, 124, 0.2);
  color: #36c17c;
}
.table-box {
  /deep/.el-form-item {
    margin-bottom: 8px !important;
  }
  /deep/ .el-form-item__content {
    width: calc(100% - 160px) !important;
  }
}
.bg-purple {
  background: #d3dce6;
}
/deep/ .el-collapse-item__header {
  background-color: #fff;
  padding: 10px 0;
  box-sizing: content-box;
}
.hover-box:hover {
  background-color: #f5f7fa;
}
.filter-label {
  font-size: 14px;
  color: #8f9bba;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin: 10px 0;
  color: #e1e1e1;
}
.balance-critical {
  background-color: rgba(233, 89, 93, 0.2);
  color: #e9595d;
}
.fdc {
  flex-direction: column;
}
.fdr {
  flex-direction: row;
}
.cover {
  width: 100%;
  height: 100%;
}

.modal-body {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}
.material-card {
  background-color: #ffffff;
  border-radius: 14px;
  padding: 20px 20px 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06),
    0 1px 1px rgba(255, 255, 255, 0.5) inset;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  position: relative;
}

.material-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1),
    0 1px 1px rgba(255, 255, 255, 0.5) inset;
}

.material-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.material-name {
  font-size: 20px;
  color: #1d1d1f;
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 1.3;
  word-break: break-word;
  max-width: 100%;
}

.tag-container {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}

.included-tag {
  background: rgba(48, 209, 88, 0.12);
  color: #25a05e;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
}

.template-tag {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
}

.feed-template {
  background: rgba(10, 132, 255, 0.12);
  color: #0066cc;
}

.process-template {
  background: rgba(191, 90, 242, 0.12);
  color: #8944b3;
}

.material-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  flex-grow: 1;
}

.info-label {
  font-size: 13px;
  color: #86868b;
  margin-bottom: 6px;
  font-weight: 500;
  letter-spacing: -0.2px;
  text-transform: uppercase;
}

.info-value {
  font-size: 16px;
  color: #1d1d1f;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

.highlight-value {
  font-size: 28px;
  font-weight: 700;
  color: #0066cc;
  margin: 4px 0 8px;
}

.material-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding: 8px 60px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.btn {
  padding: 10px 14px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  flex: 1;
  justify-content: center;
}

.btn i {
  margin-right: 5px;
  font-size: 13px;
}

.btn-theory {
  background: rgba(255, 149, 0, 0.15);
  color: #ff9500;
}

.btn-theory:hover {
  background: rgba(255, 149, 0, 0.2);
  transform: translateY(-2px);
}

.btn-edit {
  background: rgba(0, 122, 255, 0.15);
  color: #007aff;
}

.btn-edit:hover {
  background: rgba(0, 122, 255, 0.2);
  transform: translateY(-2px);
}

.btn-delete {
  background: rgba(255, 69, 58, 0.15);
  color: #ff453a;
}

.btn-delete:hover {
  background: rgba(255, 69, 58, 0.2);
  transform: translateY(-2px);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .modal-body {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .modal-body {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .material-content {
    grid-template-columns: 1fr;
  }

  .material-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }

  .material-header {
    flex-direction: column;
  }

  .material-name {
    max-width: 100%;
    margin-bottom: 10px;
  }
}

/* 优雅的动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.material-card {
  animation: fadeIn 0.4s ease-out forwards;
}

.material-card:nth-child(2) {
  animation-delay: 0.1s;
}

.material-card:nth-child(3) {
  animation-delay: 0.2s;
}

.material-card:nth-child(4) {
  animation-delay: 0.3s;
}

.material-card:nth-child(5) {
  animation-delay: 0.4s;
}

.material-card:nth-child(6) {
  animation-delay: 0.5s;
}
</style>